module.exports = __webpack_public_path__ + "img/ideation-09-milestone-phase-2.cc3d73e7.jpg";